export const formSelectData = {
	id: '',
	placeholder: '',
	type: 'text',
	label: '',
	options: [],
	isMultiselect: false,
};
